import React from 'react';
import { useParams } from 'react-router-dom';

import useWindowDimensions from '../../utils/useWindowDimensions';
import {
  MIN_ITEMS_PHOTOS_LIMIT_MOBILE,
  ITEMS_PHOTOS_LIMIT_DESKTOP,
  WIDTH_MAX_DESKTOP,
} from '../../constants/general.constants';
import Photos from '../PatientProfile/Photos';
import { useSaveServiceVisitPhotoMutation } from '../../hooks/serviceVisit/useServiceVisitPhotos';
import { preparePhotoParams } from '../../utils/serviceVisit/photo.utils';
import { AFTER_PHOTO_TYPE } from '../../constants/serviceVisits/serviceVisit.constants';
import { IServiceVisitPhoto } from '../../interfaces/IServiceVisits';

type Props = {
  isLoading: boolean;
  photos: IServiceVisitPhoto[];
  opened: boolean;
  isPhotoRequired: boolean;
};

const cardContentStyle = {
  padding: '11px 20px 20px 20px',
};

export const AfterPhotosStep = ({ isLoading, photos, isPhotoRequired, opened }: Props) => {
  const { serviceVisitId }: any = useParams();
  const { width } = useWindowDimensions();
  const savePhotoMutation = useSaveServiceVisitPhotoMutation();

  const ITEMS_PHOTOS_LIMIT_BY_SCREEN_SIZE =
    width > WIDTH_MAX_DESKTOP ? ITEMS_PHOTOS_LIMIT_DESKTOP : MIN_ITEMS_PHOTOS_LIMIT_MOBILE;

  const uploadAfterPhoto = async (files: File[]) => {
    const formData = await preparePhotoParams(files);
    formData.append('photo_type', AFTER_PHOTO_TYPE);
    formData.append('service_visit_id', serviceVisitId);
    savePhotoMutation.mutate({ serviceVisitId, formData });
  };

  return (
    <Photos
      required={isPhotoRequired && !photos.length}
      inputFileId="afterPhoto"
      cardStyles={{ marginBottom: '0' }}
      cardContentStyle={cardContentStyle}
      title={`After Photos (${isPhotoRequired ? 'required' : 'optional'})`}
      photos={photos}
      isUploadingPhoto={savePhotoMutation.isLoading}
      isLoading={isLoading}
      uploadPhotosCallback={uploadAfterPhoto}
      showUploadPhotoButton={opened}
      itemsPhotos={ITEMS_PHOTOS_LIMIT_BY_SCREEN_SIZE}
    />
  );
};
